import { GalleryCategory } from '../../../mocks/galleryData';

const TABS: GalleryCategory[] = [
  'All',
  'Weddings',
  'Festivals',
  'Corporate & Private Events',
  'Bespoke Decor',
  'Markets & Outdoor',
  'Custom Skins',
];

interface FilterTabsProps {
  active: GalleryCategory;
  onChange: (cat: GalleryCategory) => void;
}

export default function FilterTabs({ active, onChange }: FilterTabsProps) {
  return (
    <div className="sticky top-24 z-30 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-1 overflow-x-auto py-4 scrollbar-hide">
          {TABS.map((tab, i) => (
            <button
              key={tab}
              onClick={() => onChange(tab)}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer ${i === 0 ? 'ml-auto ' : ''}${i === TABS.length - 1 ? 'mr-auto ' : ''}${
                active === tab
                  ? 'bg-teal-400 text-white shadow-sm'
                  : 'text-gray-600 hover:text-teal-500 hover:bg-teal-50'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
